module.exports = __webpack_public_path__ + "static/media/1-Y.8df60c11.mp3";